import { browser } from "$app/environment";

/**
 * Twins drawer open/close + prefill state.
 *
 * The drawer lives outside any single screen (mounted at the layout level)
 * so multiple call sites — header button, deep-link `?bond=...`, Settings
 * "Manage twins" — can drive it without prop-drilling. Prefill fields let
 * the deep-link path land the user inside the inline "Add twin" card with
 * the friend's bond code already pasted.
 *
 * Body scroll-lock is applied on open and reverted on close so the drawer
 * body can scroll without fighting the page underneath.
 */

interface OpenOptions {
  code?: string;
  handle?: string;
}

class TwinsDrawerState {
  open = $state<boolean>(false);
  prefillCode = $state<string>("");
  prefillHandle = $state<string>("");

  openDrawer(opts: OpenOptions = {}): void {
    if (typeof opts.code === "string") this.prefillCode = opts.code;
    if (typeof opts.handle === "string") this.prefillHandle = opts.handle;
    this.open = true;
    this.lockScroll(true);
  }

  close(): void {
    this.open = false;
    this.prefillCode = "";
    this.prefillHandle = "";
    this.lockScroll(false);
  }

  toggle(): void {
    if (this.open) this.close();
    else this.openDrawer();
  }

  private lockScroll(lock: boolean): void {
    if (!browser) return;
    document.body.style.overflow = lock ? "hidden" : "";
  }
}

export const twinsDrawer = new TwinsDrawerState();
